var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"el-container"},[_c('el-aside',{attrs:{"width":"auto"}},[_c('common-aside')],1),_c('el-container',[_c('el-header',{staticClass:"el-header"},[_c('common-head')],1),_c('el-main',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }